<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shuttle-file-search-section"
        id="shuttle-file-search-section"
      >
        <el-form
          id="shuttle-file-search-section-form"
          class="search-section-form"
          :model="searchFormModel"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.dayOfService')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleChangeDate"
                  v-model="searchFormModel.receivingDate"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.consignee')">
                <autocomplete
                  :model.sync="searchFormModel.consigneeAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlConsignee"
                  labelField="name"
                  valueField="id"
                  ref="consignee"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.outboundWarehouse')" class="outbound-warehouse-form-label">
                <outbound-warehouse-select v-model="searchFormModel.outboundWarehouseId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.shuttle')">
                <el-select v-model="searchFormModel.shuttle" @change="handleSearch">
                  <el-option
                    v-for="option in shuttleOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.state')">
                <state-select v-model="searchFormModel.stateId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('routing.shuttleFile.city')">
                <autocomplete
                  :model.sync="searchFormModel.city"
                  popperAppendToBody
                  :url="cityUrl"
                  labelField="name"
                  valueField="id"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="shuttle-file-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from '@/components/Autocomplete';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import { SHUTTLE_FILE_SEARCH } from '@/store/actions';
import OutboundWarehouseSelect from '../components/OutboundWarehouseSelect';
import StateSelect from '../components/StateSelect';

export default {
  name: 'ShuttleFileSearchSection',
  components: { Autocomplete, OutboundWarehouseSelect, StateSelect },
  computed: {
    ...mapGetters(['shuttleFile']),
    shuttleOptions() {
      return [
        {
          value: null,
          label: this.$t('common.all')
        },
        {
          value: constants.STATUS_BOOLEAN.yes.value,
          label: constants.STATUS_BOOLEAN.yes.label
        },
        {
          value: constants.STATUS_BOOLEAN.no.value,
          label: constants.STATUS_BOOLEAN.no.label
        }
      ];
    },
    urlConsignee() {
      return apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE;
    },
    cityUrl() {
      return apiConstants.END_POINTS.ROUTING.CITIES;
    }
  },
  data() {
    return {
      activeCollapsibleName: ['shuttle-file-search-section'],
      isOpen: ['shuttle-file-search-section'],
      searchFormModel: {
        receivingDate: new Date(),
        consigneeAccountId: null,
        outboundWarehouseId: null,
        shuttle: null,
        stateId: null,
        city: null
      }
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(SHUTTLE_FILE_SEARCH, this.searchFormModel);
    },
    handleChangeDate() {
      this.handleSearch();
      this.$refs.consignee.$el.getElementsByTagName('input')[0].focus();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.outbound-warehouse-form-label {
  .el-form-item__label {
    line-height: 1.15;
  }
}
</style>
